// v3.7.6: Full implementation — migrated from ChatSidebar.tsx
import React from 'react';
import { Bot, Grid3X3, Zap, Workflow, MoreHorizontal } from 'lucide-react';

interface NavSection {
  id: string; icon: React.ReactNode; labelZh: string; labelEn: string; tab?: string;
}

// P3-7: tab field maps to DesktopUI activeTab values. 'ecosystem' = Project Space (not 'projects')
const NAV_SECTIONS: NavSection[] = [
  { id: 'assistant', icon: <Bot size={16} />, labelZh: '助理', labelEn: 'Assistant' },
  { id: 'ecosystem', icon: <Grid3X3 size={16} />, labelZh: '项目空间', labelEn: 'Projects', tab: 'ecosystem' },
  { id: 'skills', icon: <Zap size={16} />, labelZh: '技能中心', labelEn: 'Skills', tab: 'skills' },
  { id: 'automation', icon: <Workflow size={16} />, labelZh: '自动化', labelEn: 'Automation', tab: 'automation' },
  { id: 'more', icon: <MoreHorizontal size={16} />, labelZh: '更多', labelEn: 'More', tab: 'more' },
];

interface SidebarNavProps {
  activeTab: string | undefined;
  onNavigate: (tab: string) => void;
  isZh: boolean;
  runningPlanCount: number;
}

export const SidebarNav = React.memo(function SidebarNav(props: SidebarNavProps) {
  const { activeTab, onNavigate, isZh, runningPlanCount } = props;
  return (
    <div className="px-3 pb-3 space-y-0.5">
      {NAV_SECTIONS.map((item) => {
        const badge = item.id === 'automation' ? (runningPlanCount || undefined) : undefined;
        return (
          <button
            key={item.id}
            aria-current={activeTab === item.id || (item.tab && activeTab === item.tab) ? "page" : undefined} aria-label={isZh ? item.labelZh : item.labelEn} onClick={() => onNavigate(item.tab || item.id)}
            className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm
              transition-all duration-200 group
              ${activeTab === item.id || (item.tab && activeTab === item.tab)
                ? 'bg-white/[0.08] text-celestial-saturn'
                : 'text-white/50 hover:text-white/80 hover:bg-white/[0.04]'
              }`}
          >
            <span className={`${activeTab === item.id ? 'text-celestial-saturn' : 'text-white/35 group-hover:text-white/60'} transition-colors`}>
              {item.icon}
            </span>
            <span className="font-medium">{isZh ? item.labelZh : item.labelEn}</span>
            {badge ? (
              <span className="ml-auto text-[10px] font-bold text-black bg-celestial-saturn px-1.5 py-0.5 rounded-full">
                {badge}
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
});
